import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    username: '',
    accesos: [],
    empresa: '',
    emisorSeleccionado: {},
    rol: '',
    asignaciones: {},
    userAccess: []
};
export const sessionReducer = createSlice({
    name: 'session',
    initialState: initialState,
    reducers: {
        login: (state, action) => {
            state.username = action.payload.username;
            state.accesos = action.payload.accesos;
            state.rol = action.payload.rol;
            state.permisos = action.payload.permisos;
            state.asignaciones = action.payload.asignaciones;
            state.empresa = action.payload.empresa;
        },
        logout: (state) => {
            return { ...initialState };
        },
        setEmisor: (state, action) => {
            state.emisorSeleccionado = action.payload;
        },
        setUserAccess(state, action) {
            state.userAccess = action.payload;
        }
    }
});

// Action creators are generated for each case reducer function
export const { login, logout, setEmisor, setUserAccess } = sessionReducer.actions;

export default sessionReducer.reducer;
